import React, { useEffect, useState } from 'react'

import DocumentViewer from '../../../../DocumentViewer'
import { useSelector } from 'react-redux'

function File(props) {
  const [url, setUrl] = useState('')
  const { iFrameKey } = useSelector((state) => state.courses)

  useEffect(() => {
    setTimeout(() => {
      setUrl(props.url)
    }, 100)
  }, [])

  return (
    <div className='fullscreen-presentation h-100'>
      <DocumentViewer url={url} {...props} />
    </div>
  )
}

export default File
